import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import CircularProgress from 'material-ui/CircularProgress'

const getMember = (team, userId) => {
  let loadingTeam = team === undefined
  if (!loadingTeam) {
    const loadingMembers = !team.members || team.members.loading
    const loadingMetadata = !team.metadata || team.metadata.loading
    loadingTeam = loadingMembers || loadingMetadata
  }
  if (!loadingTeam) {
    return team.members.value && team.members.value.find(m => m.userId === userId)
  }
  return null
}

const mapStateToProps = state => ({
  team: state.firebase.team,
  userId: state.firebase.userAuth.id
})

/**
 * HOC that Handles whether or not the user is allowed to see the page.
 * @param {array} allowedRoles - user roles that are allowed to see the page.
 * @returns {Component}
 */
const Authorization = allowedRoles => WrappedComponent => {
  class WithAuthorization extends React.Component {

    static propTypes = {
      userId: PropTypes.string.isRequired,
      team: PropTypes.object
    }

    render() {
      const { team, userId } = this.props
      const member = getMember(team, userId)
      // If the team member is not available, show the loading indicator.
      if (!member) {
        return <div style={styles.status}>
          <CircularProgress thickness={2} size={60} />
        </div>
      }
      const props = Object.assign({}, this.props, { member })
      if (allowedRoles.includes(member.access)) {
        return <WrappedComponent {...props} />
      } else {
        return <div style={{ ...styles.status, ...styles.forbidden }}>{'You don\'t have access to this!'}</div>
      }
    }

  }

  return connect(mapStateToProps)(WithAuthorization)

}

export default Authorization

const styles = {
  status: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    marginTop: 100
  },
  forbidden: {
    fontSize: 18,
    color: '#f00'
  }
}



// WEBPACK FOOTER //
// ./src/infra/Authorization.js